// extracted by mini-css-extract-plugin
module.exports = {"bottomGradient":"background-image-module--bottomGradient--3PMxo"};